import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ClientProvider } from "@/context/ClientContext";
import { TopStatsBar, DashboardHeader } from "@/components/game/TopStatsBar";
import ClientsDashboard from "@/pages/ClientsDashboard";
import ClientHome from "@/pages/ClientHome";
import LevelMap from "@/pages/LevelMap";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import Login from "@/pages/Login";
import Assessment from "@/pages/Assessment";
import Practice from "@/pages/Practice";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <Loader2 className="w-10 h-10 text-[#29ABE2] animate-spin" />
    </div>
  );
}

function DashboardLayout() {
  return (
    <>
      <DashboardHeader />
      <Outlet />
    </>
  );
}

function ClientLayout() {
  return (
    <ClientProvider>
      <TopStatsBar />
      <Outlet />
    </ClientProvider>
  );
}

function AuthedApp() {
  return (
    <Routes>
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<ClientsDashboard />} />
      </Route>
      <Route path="/clients/:clientId" element={<ClientLayout />}>
        <Route index element={<ClientHome />} />
        <Route path="topic/:topicId" element={<LevelMap />} />
        <Route path="play/:topicId/:difficulty/:mode" element={<Quiz />} />
        <Route path="results" element={<Results />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function Gate() {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/login" element={<Navigate to="/" replace />} />
      <Route path="/*" element={<AuthedApp />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/assess/:token" element={<Assessment />} />
            <Route path="/practice/:token" element={<Practice />} />
            <Route path="/*" element={<Gate />} />
          </Routes>
        </AuthProvider>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
